export interface IEmail {
  fromEmail: string;
  toEmails: string;
  subject: string;
  htmlContent: string;
}
